export interface LoginSchema {
  email: string;
  password: string;
}

export interface ValidationResult {
  success: boolean;
  data?: LoginSchema;
  errors?: Partial<Record<keyof LoginSchema, string>>;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateLogin(input: LoginSchema): ValidationResult {
  const errors: Partial<Record<keyof LoginSchema, string>> = {};

  if (!input.email.trim()) {
    errors.email = "required";
  } else if (!EMAIL_RE.test(input.email.trim())) {
    errors.email = "invalid";
  }

  if (!input.password.trim()) {
    errors.password = "required";
  }

  if (errors.email || errors.password) {
    return { success: false, errors };
  }

  return {
    success: true,
    data: {
      email: input.email.trim(),
      password: input.password
    }
  };
}
